export const environment = {
    disableConsoleLogging: true,

    production: true,
    apiEndpoint: 'https://bv-stage.oekoplan.cz:8443',
    // apiEndpoint: 'https://bv-stage.oekoplan.cz:8443'
    // apiEndpoint: 'https://bv-stage.oekoplan.cz:8443'
    // apiEndpoint: 'https://bv-stage.oekoplan.cz:8443'
};
